import { get } from "../libs/https";
import Vue from "vue";
const publicPath = process.env.BASE_URL;

export const getSiteTheme = async () => {
  let res = await get(`${publicPath}api/theme`);
  if (res.theme) {
    Vue.prototype.$theme = res.theme;

    // Add Custom Style
    let style = document.createElement('style');
    style.innerText = `
    html { background-color: ${res.theme.background} !important; }
    body { color: ${res.theme.fontColor} !important}
    h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 { color: ${res.theme.fontColor} !important}
    .fontPrimary { color: ${res.theme.fontColor} !important}
    .info { color: ${res.theme.info} !important}
    .infoLight { color: ${res.theme.infoLight} !important}
    .success { color: ${res.theme.success} !important}
    .successLight { color: ${res.theme.successLight} !important}
    .primary { color: ${res.theme.primary} !important}
    .primaryLight { color: ${res.theme.primaryLight} !important}
    .warning { color: ${res.theme.warning} !important}
    .warningLight { color: ${res.theme.warningLight} !important}
    .danger { color: ${res.theme.danger} !important}
    .dangerLight { color: ${res.theme.dangerLight} !important}
    .default { color: ${res.theme.default} !important}
    .defaultLight { color: ${res.theme.defaultLight} !important}
    .text-muted { color: ${res.theme.fontColorLight} !important}
    .c-background { color: ${res.theme.background} !important}
    `
    let head = document.head;
    head.appendChild(style);

    // Change Favicon
    let fIcon = document.getElementById('favicon');
    if (fIcon && res.theme.icons.favicon) {
      fIcon.href = res.theme.icons.favicon
    } 

    // Change Description
    let desc = document.getElementById('cusDesc');
    if (desc && res.theme.description) {
      desc.content = res.theme.description
    } 

    // Change Title
    let title = document.querySelector('title');
    if (title && res.theme.title) {
      title.innerText = res.theme.title
    } 
    let event = new CustomEvent("theme");
    window.dispatchEvent(event);
  } 
};

export const getSiteFooter = async () => {
  return await get(`${publicPath}api/theme/footer`);
}